import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
export interface Testimonial {
  initials: string;
  name: string;
  location: string;
  text: string;
  color: string;
  pack?: string;
}
interface TestimonialsProps {
  testimonials: Testimonial[];
  title?: string;
  className?: string;
}
export function Testimonials({
  testimonials,
  title,
  className = ''
}: TestimonialsProps) {
  return <section className={`py-16 bg-zinc-900 ${className}`} data-id="element-203">
      <div className="container mx-auto px-4" data-id="element-204">
        {title && <h2 className="font-bold text-center mb-12 text-white text-[16px] md:text-2xl" data-id="element-205">
            {title}
          </h2>}

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-6xl mx-auto" data-id="element-206">
          {testimonials.map((t, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: i * 0.1
        }} className="bg-black/70 p-6 rounded-2xl shadow-lg border border-sky-900/40 flex flex-col h-full" data-id="element-207">
              <div className="flex items-center gap-1 mb-4" data-id="element-208">
                {[...Array(5)].map((_, j) => <Star key={j} className="w-4 h-4 text-sky-400 fill-sky-400" data-id="element-209" />)}
              </div>

              <p className="text-zinc-100 italic mb-6 flex-grow" data-id="element-210">"{t.text}"</p>

              <div className="flex items-center gap-3 mt-auto pt-4 border-t border-sky-900/30" data-id="element-211">
                <div className={`w-10 h-10 rounded-full flex items-center justify-center text-white font-bold text-sm ${t.color}`} data-id="element-212">
                  {t.initials}
                </div>
                <div data-id="element-213">
                  <p className="font-bold text-white text-sm" data-id="element-214">{t.name}</p>
                  <p className="text-xs text-sky-200" data-id="element-215">{t.location}</p>
                  {t.pack && <p className="text-xs font-medium text-sky-300 mt-0.5" data-id="element-216">
                      {t.pack}
                    </p>}
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}
export const initialTestimonials: Testimonial[] = [{
  initials: 'MR',
  name: 'Martín R.',
  location: 'Emprendedor · Buenos Aires',
  text: 'Descargué el pack, lo llevé a la imprenta del barrio y en tres días ya había recuperado lo invertido. Nunca había vendido nada y fue más fácil de lo que pensaba.',
  color: 'bg-sky-600'
}, {
  initials: 'LG',
  name: 'Laura G.',
  location: 'Ama de casa · Rosario',
  text: 'Los stickers del Mundial se venden solos. Yo solo los imprimí y los ofrecí en el grupo de WhatsApp del trabajo. En una semana vendí todo.',
  color: 'bg-sky-700'
}, {
  initials: 'FP',
  name: 'Federico P.',
  location: 'Estudiante · Mendoza',
  text: 'Tenía miedo de no saber cómo arrancar. Pero con +7.000 diseños listos no tuve que pensar nada — solo elegí los que más me gustaron, imprimí y vendí.',
  color: 'bg-sky-800'
}];
export const moreTestimonials: Testimonial[] = [{
  initials: 'JM',
  name: 'Julián M.',
  location: '🏙️ Buenos Aires',
  text: 'Imprimí los stickers de Messi y los de la Selección y los vendí en la puerta del colegio de mis hijos. En un fin de semana saqué para pagar el pack diez veces.',
  color: 'bg-sky-700'
}, {
  initials: 'DS',
  name: 'Daniela S.',
  location: '🏙️ Santa Fe',
  text: 'Los stickers variados me sorprendieron. No son solo de fútbol — hay de todo. Ahora vendo todo el año, no solo cuando hay Mundial.',
  color: 'bg-sky-800'
}, {
  initials: 'CP',
  name: 'Carlos P.',
  location: '🏙️ Tucumán',
  text: 'Lo compré un viernes a la noche, lo descargué, el sábado lo llevé a imprimir y el domingo ya estaba vendiendo en la feria. Funciona.',
  color: 'bg-sky-600'
}, {
  initials: 'MG',
  name: 'Marcela G.',
  location: '🏙️ Rosario',
  text: 'Nunca había vendido nada. Con este pack arranqué mi primer negocio y ahora tengo clientes fijos que me piden reposición.',
  color: 'bg-sky-900'
}];